import React, { useEffect, useState } from "react";
import { Select } from "@windmill/react-ui";
import OneWayPickupServices from "services/OnewayPickupServices";
import VehicleCategoryServices from "services/VehicleCategoryServices";

const SelectOnewayVehicle = ({
  register,
  name,
  label,
  selectedPackage,
  handleType,
  handleSeat,
  setValue,
  defaultValue,
}) => {
  const [vehicleList, setVehicleList] = useState([]);
  const [selectedVehicleId, setSelectedVehicleId] = useState("");
  const [packageList, setPackageList] = useState([]);
  const [vehicleCategory, setVehicleCategory] = useState([]);

//   console.log("default val", defaultValue);

  useEffect(() => {
  if (!defaultValue) {
    setSelectedVehicleId("");
    setVehicleList([]);

    setValue("vehicle_type", "");
    if (handleSeat) handleSeat(null);
    if (handleType) handleType("");
  }
}, [defaultValue]);

  // Fetch package list
  useEffect(() => {
    async function fetchVehicle() {
      try {
        const response =
          await OneWayPickupServices.getAllOnewayPickupBasicRate();

        // console.log("vehicle api response", response.data);
        setPackageList(response.data);
      } catch (error) {
        console.error("Vehicle fetch error", error);
      }
    }

    fetchVehicle();
  }, []);

  // Fetch vehicle category (for seat count)
  useEffect(() => {
    async function fetchVehicleCategory() {
      try {
        const response =
          await VehicleCategoryServices.getAllVehicleCategory();

        setVehicleCategory(response.data);
      } catch (error) {
        console.error("Error fetching category:", error);
      }
    }

    fetchVehicleCategory();
  }, []);

//   console.log("choosed package", selectedPackage);

  // Load vehicles when package changes
  useEffect(() => {
    if (!selectedPackage) return;

    if (
      selectedPackage.vehicle_type_names &&
      selectedPackage.vehicle_type_ids
    ) {
      const ids = selectedPackage?.vehicle_type_ids?.flat() || [];
      const nameMap = selectedPackage?.vehicle_type_names || {};
 
      const vehicles = ids.map((id) => {
        const vehicleCat = vehicleCategory.find(
          (cat) => Number(cat.id) === Number(id)
        );

        return {
          id: Number(id),
          name: nameMap[id],
          seat: vehicleCat ? vehicleCat.seats : null,
        };
      });

      setVehicleList(vehicles);

      // retain vehicle while editing
      if (defaultValue || vehicles.length > 0) {
        const vehicle = vehicles.find(
          (v) => v.id === Number(defaultValue)
        );

        if (vehicle) {
          setSelectedVehicleId(vehicle.id);
          setValue("vehicle_type", vehicle.id);
          handleType(vehicle.id);

          if (handleSeat) {
            handleSeat(vehicle.seat);
          }
        }
      }
    }
  }, [selectedPackage, defaultValue, vehicleCategory, setValue]);

  const handleChange = (e) => {
    const selectedId = Number(e.target.value);

    // console.log("selected pack", selectedId);

    handleType(selectedId);

    const vehicle = vehicleList.find(
      (v) => v.id === Number(selectedId)
    );

    setSelectedVehicleId(selectedId);

    // set seat for adult dropdown
    if (vehicle && handleSeat) {
      handleSeat(vehicle.seat);
    }

    setValue("vehicle_type", selectedId);

    // Auto fill selling price
    if (selectedPackage?.min_rate?.[selectedId]) {
      setValue("selling_price", selectedPackage.min_rate[selectedId]);
    }
  };

  return (
    <Select
      className="border h-10 text-sm focus:outline-none block w-full bg-white"
      {...register(name, { required: `${label} is required!` })}
      value={selectedVehicleId || ""}
      onChange={handleChange}
    >
      <option value="">Select Vehicle</option>

      {vehicleList?.length === 0 ? (
        <option>Loading...</option>
      ) : (
        vehicleList.map((vehicle) => (
          <option key={vehicle.id} value={vehicle.id}>
            {vehicle.name}
          </option>
        ))
      )}
    </Select>
  );
};

export default SelectOnewayVehicle;